import { MNEMONICS } from './mnemonics';
export const DATETIME_INDEX_TYPE = 'date time';
export const DEPTH_INDEX_TYPE = 'measured depth';

export enum MnemonicCategory {
  TimeData = 'timeData',
}

export const KICK_PREDICTION_DATA_MANAGEMENT_MNEMONICS = [
  MNEMONICS.BITDEP,
  MNEMONICS.HKLDAV,
  MNEMONICS.DEPTH,
  MNEMONICS.BLOCK_POSITION,
  MNEMONICS.FLOWINAV,
  MNEMONICS.RPM,
  MNEMONICS.WOBAV,
  MNEMONICS.PRESPUMPPAV,
  MNEMONICS.TQAV,
  MNEMONICS.WTMUDINAV,
  MNEMONICS.TEMP_MUD_OUT,
  MNEMONICS.GASOUTAV,
  MNEMONICS.FLOWIN_BST,
  MNEMONICS.ECDPWD,
];

export const STUCK_PREDICTION_DATA_MANAGEMENT_MNEMONICS = [
  MNEMONICS.BITDEP,
  MNEMONICS.HKLDAV,
  MNEMONICS.DEPTH,
  MNEMONICS.BLOCK_POSITION,
  MNEMONICS.FLOWINAV,
  MNEMONICS.RPM,
  MNEMONICS.WOBAV,
  MNEMONICS.PRESPUMPPAV,
  MNEMONICS.TQAV,
  MNEMONICS.WTMUDINAV,
  MNEMONICS.VBITDEP,
  MNEMONICS.INCC,
  MNEMONICS.ECDPWD,
];

export const KICK_DETECTION_DATA_MANAGEMENT_MNEMONICS = [
  MNEMONICS.BITDEP,
  MNEMONICS.HKLDAV,
  MNEMONICS.DEPTH,
  MNEMONICS.BLOCK_POSITION,
  MNEMONICS.FLOWINAV,
  MNEMONICS.RPM,
  MNEMONICS.WOBAV,
  MNEMONICS.PRESPUMPPAV,
  MNEMONICS.ACTIVE_VOLUME,
  MNEMONICS.TTVOL01,
  MNEMONICS.FLOWOUTAV,
  MNEMONICS.FLOWOUTPC,
  MNEMONICS.FLOWIN_BST,
];

export const ALL_DATA_MANAGEMENT_MNEMONICS = [
  MNEMONICS.BITDEP,
  MNEMONICS.HKLDAV,
  MNEMONICS.DEPTH,
  MNEMONICS.BLOCK_POSITION,
  MNEMONICS.FLOWINAV,
  MNEMONICS.RPM,
  MNEMONICS.WOBAV,
  MNEMONICS.PRESPUMPPAV,
  MNEMONICS.TQAV,
  MNEMONICS.WTMUDINAV,
  MNEMONICS.TEMP_MUD_OUT,
  MNEMONICS.VBITDEP,
  MNEMONICS.GASOUTAV,
  MNEMONICS.ACTIVE_VOLUME,
  MNEMONICS.TTVOL01,
  MNEMONICS.FLOWIN_BST,
  MNEMONICS.ECDPWD,
  MNEMONICS.INCC,
  MNEMONICS.FLOWOUTAV,
  MNEMONICS.FLOWOUTPC,
];
